var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status",class:{
    'error': _vm.activeClass == 'error',
    'complete': _vm.activeClass == 'complete',
    'warning': _vm.activeClass == 'warning',
  }},[(_vm.header)?_c('div',{staticClass:"status__header"},[_vm._v(_vm._s(_vm.header))]):_vm._e(),_c('div',{staticClass:"status__message"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }